import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a0ae2a6c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a0ae2a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ae2a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0ae2a6c')) {
      api.createRecord('a0ae2a6c', component.options)
    } else {
      api.reload('a0ae2a6c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a0ae2a6c&scoped=true&", function () {
      api.rerender('a0ae2a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eCQKJWcDnXJY/JS/comp/Voucher.vue"
export default component.exports